const FAQ = () => import( /* webpackChunkName: "faq" */ './FAQ');

export default {
  path: '/faq',
  component: FAQ,
  name: 'faq',
};